// extracted by mini-css-extract-plugin
export var downArrow = "_7c-0";
export var label = "_7c-1";
export var treatmentCard = "_7c-3";
export var upArrow = "_7c-2";